import * as ActionTypes from './actionTypes'

export const resetSessionId = (sessionId, sessionIdStateLocation, activeSessionStateLocation) =>
{
    return {
        type: ActionTypes.SET_SESSION_ID,
        payload:
        {
            sessionId,
            sessionIdStateLocation,
            activeSessionStateLocation
        }
    }
};

export function appendHistoryMessage(message, stateLocation)
{
    return {
        type: ActionTypes.APPEND_HISTORY_MESSAGE,
        payload:
        {
            message,
            stateLocation
        }
    }
}

export function clearHistoryMessages(stateLocation)
{
    return {
        type: ActionTypes.CLEAR_HISTORY_MESSAGES,
        payload:
        {
            stateLocation
        }
    }
}

export function hideTimeoutWarningAction(stateLocation)
{
    return {
        type: ActionTypes.HIDE_TIMEOUT_WARNING,
        payload:
        {
            stateLocation
        }
    }
}

export function refreshPersistedStateAction(stateLocation)
{
    return {
        type: ActionTypes.REFRESH_PERSISTED_STATE,
        payload:
        {
            stateLocation,
        }
    }
}

export function setInactivityTimeAction(time, stateLocation)
{
    return {
        type: ActionTypes.SET_INACTIVITY_TIME,
        payload:
        {
            time,
            stateLocation
        }
    }
}

export function setSessionStartTimeAction(time, stateLocation)
{
    return {
        type: ActionTypes.SET_SESSION_START_TIME,
        payload:
        {
            time,
            stateLocation
        }
    }
}

export function showTimeoutWarningAction(stateLocation)
{
    return {
        type: ActionTypes.SHOW_TIMEOUT_WARNING,
        payload:
        {
            stateLocation
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/lib-end-session/lib/actions/actions.js